import React from 'react';

import style from './follow.module.scss';

import facebook from '../../assets/image/footer/facebook.png';
import linkedin from '../../assets/image/footer/linkedin.png';
import skype from '../../assets/image/footer/skype.png';
import telegram from '../../assets/image/footer/telegram.png';
import twitter from '../../assets/image/footer/twitter.png';
import whatsapp from '../../assets/image/footer/whatsapp.png';

const whatsappNumber = '8615369357369';

export const Follow = () => {
    return (
        <div className={style.followUs}>
            <div className={style.followUsItem}>
                <div className={style.followUsTitle}>Follow Us:</div>
            </div>
            <div className={style.followUsItem}>
                <img alt="" src={facebook} className={style.followUsIcon}></img>
            </div>
            <div className={style.followUsItem}>
                <img alt="" src={linkedin} className={style.followUsIcon}></img>
            </div>
            <div className={style.followUsItem}>
                <img alt="" src={skype} className={style.followUsIcon}></img>
            </div>
            <div className={style.followUsItem}>
                <img alt="" src={telegram} className={style.followUsIcon}></img>
            </div>
            <div className={style.followUsItem}>
                <img alt="" src={twitter} className={style.followUsIcon}></img>
            </div>
            <div className={style.followUsItem}>
                <a className={style.followLink} href={`https://wa.me/${whatsappNumber}`} target="_blank" rel="noreferrer">
                    <img alt="" src={whatsapp} className={style.followUsIcon}></img>
                </a>
            </div>
        </div>
    );
};
